import { render, staticRenderFns } from "./ActiveHistory.vue?vue&type=template&id=7095fd96&"
import script from "./ActiveHistory.vue?vue&type=script&lang=js&"
export * from "./ActiveHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports